import React from 'react';

import styled from 'styled-components';

// theme
import aampeTheme from '../../constants/aampeTheme';

interface CardProps {
    title: string;
    subtitle?: string;
    children: any;
}

const BaseCard: React.FC<React.PropsWithChildren<CardProps>> = ({
    title,
    subtitle,
    children,
}) => {
    return (
        <Container>
            <Header>
                <Title>{title}</Title>
                {subtitle && <Subtitle>{subtitle}</Subtitle>}
            </Header>
            {children}
        </Container>
    );
};

export default BaseCard;

const Container = styled.div({
    zIndex: 3,
    backgroundColor: aampeTheme.colors.white,
    borderRadius: aampeTheme.borderRadius.default,
    boxShadow:
        '0px 4px 8px -2px rgba(16, 24, 40, 0.1), 0px 2px 4px -2px rgba(16, 24, 40, 0.06)',
    maxWidth: '440px',
    width: '100%',
    margin: aampeTheme.spacing(1),
    padding: aampeTheme.spacing(5),
    display: 'flex',
    flexFlow: 'column nowrap',
    justifyContent: 'center',
    alignItems: 'center',
    maxHeight: '100vh',
    overflowY: 'auto',
});

const Header = styled.div({
    marginBottom: aampeTheme.spacing(4),
});

const Title = styled.h1({
    fontWeight: 600,
    fontSize: '30px',
    lineHeight: '38px',
    textAlign: 'center',
    margin: 0,
});

const Subtitle = styled.p({
    fontSize: '16px',
    lineHeight: '20px',
    textAlign: 'center',
    color: aampeTheme.colors.gray600,
    margin: aampeTheme.spacing(1, 0, 0, 0),
});
